import { render, staticRenderFns } from "./Snacks.vue?vue&type=template&id=7c10eb95&scoped=true&"
import script from "./Snacks.vue?vue&type=script&lang=js&"
export * from "./Snacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c10eb95",
  null
  
)

export default component.exports